import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FormControl } from '@angular/forms';
import { SearchService, SEARCH_TYPE_CUENTA, SEARCH_TYPE_COLABORADOR, SEARCH_TYPE_MOTOR, SEARCH_TYPE_LABEL } from '../../../services/search-service';
import { CuentasService } from '../../../services/cuentas-service';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';
import * as moment from 'moment';
import { ColaboradorAutocompleteComponent, EtiquetaAutocompleteComponent } from '../../../components/common/autocomplete';

@Component({
  selector: 'app-buscador-cuentas-filter',
  templateUrl: './buscador-cuentas-filter.component.html',
  styleUrls: ['./buscador-cuentas-filter.component.scss']
})
export class BuscadorCuentasFilterComponent implements OnInit {

  private moreActiveFirst = false;
  public showFilters = false;
  
  @Output() onFiltersApplied = new EventEmitter();

  @ViewChild(ColaboradorAutocompleteComponent) colaboradorAutocompleteComponent;  
  @ViewChild(EtiquetaAutocompleteComponent) etiquetaAutocompleteComponent;  
  
  constructor(private dateAdapter: DateAdapter<Date>,
              private cuentasService: CuentasService,
              private searchService: SearchService) { 

    
  }

  ngOnInit() {
  }

  onApply(e){
    // dont hide the filter window when clicking the apply button
    e.stopPropagation();

    this.onFiltersApplied.emit({
      moreActiveFirst: this.moreActiveFirst,
      colaboradores: this.colaboradorAutocompleteComponent.selectedColaboradores,
      etiquetas: this.etiquetaAutocompleteComponent.selectedEtiquetas
    });
  }

  cleanFilters(e) {
    this.moreActiveFirst = false;
    this.colaboradorAutocompleteComponent.selectedColaboradores = [];
    this.etiquetaAutocompleteComponent.selectedEtiquetas = [];

    this.onApply(e);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/buscador/buscador-cuentas-filter/buscador-cuentas-filter.component.ts